export { default as Home } from "../pages/Home";
export { default as About } from "../pages/About";
export { default as NavBar } from "./NavBar";
